/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Bookmark",
  size: 20
}

const SvgBookmark = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path fill="none" d="M5.5 1.5h10v16l-5-5-5 5z" />
  </Svg>
)

SvgBookmark.defaultProps = defaultProps
export default SvgBookmark
